/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

 require('./bootstrap');
 import Vue from 'vue';

    import VueSplide from '@splidejs/vue-splide';
    Vue.use( VueSplide );
    import "@splidejs/splide/dist/css/themes/splide-default.min.css";
    
    var VueScrollTo = require('vue-scrollto');
    Vue.use( VueScrollTo );
    
// Vue components
    // Slider
    Vue.component('slider', require('./components/Slider.vue').default);
    // Map Section
    Vue.component('mapsection', require('./components/Mapsection.vue').default);
    // Whitepaper
    Vue.component('whitepaper', require('./pages/Whitepaper.vue').default);
    // Appointment
    Vue.component('appointment', require('./pages/Appointment.vue').default);
    // WhitepaperForm
    Vue.component('whitepaper-form', require('./components/WhitepaperForm.vue').default);
    // Impressum
    Vue.component('impressum', require('./pages/Impressum.vue').default);
    // Dataprivacy
    Vue.component('dataprivacy', require('./pages/DataPrivacy.vue').default);
    // Agb
    Vue.component('agb', require('./pages/Agb.vue').default);
    // Newsletter
    Vue.component('newsletter', require('./pages/Newsletter.vue').default);
 
const app = new Vue({}).$mount('#app');

jQuery(window).ready(function (e) {

    // Remove the # from the hash
    var loadTarget = location.hash.replace('#', '');

    if (loadTarget != '') {

        var $loadTarget = jQuery('#' + loadTarget);
        jQuery('html, body').stop().animate({
            'scrollTop': $loadTarget.offset().top
        }, 0, 'swing', function () {
            window.location.hash = '#' + loadTarget;
        });

    }
});

document.addEventListener('DOMContentLoaded', (event) => {
    console.log('Vue');
    //Close Navbar for mobile after Click
    $('#menu ul li a').on("click", function (e) {

        $('#menu').click().removeClass("show");
        $('.navbar-toggler').attr("aria-expanded", false)
    });
    $('.navbar-brand').on("click", function (e) {
        $('#menu').click().removeClass("show");
        $('.navbar-toggler').attr("aria-expanded", false)
    });

    var navbar = document.getElementById("menu");


    var links = navbar.getElementsByClassName("nav-link");

    for (var i = 0; i < links.length; i++) {
        links[i].addEventListener("click", function () {
            var current = document.getElementsByClassName("nav-link-active");

            if (current.length > 0) {
                current[0].className = current[0].className.replace(" nav-link-active", "");
            }

            this.className += " nav-link-active";
        });
    }

    $(document).ready(function () {
        if (window.location.hash == "#unsere-services") {
            $('#nav-link-service').addClass("nav-link-active");
        }
        else if (window.location.hash == "#unsere-kompetenzen") {
            $('#nav-link-kompetenz').addClass("nav-link-active");
        }

    });
});
 